var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusiness4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2791.43 2800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#18174a;}.cls-3{fill:#2b69b3;}.cls-4{fill:#bdd0fb;}.cls-5,.cls-7,.cls-8{fill:#fff;}.cls-6{fill:url(#linear-gradient-2);}.cls-7{opacity:0.76;}.cls-8{opacity:0.77;}.cls-9{fill:url(#linear-gradient-3);}.cls-10{fill:url(#linear-gradient-4);}.cls-11{fill:url(#linear-gradient-5);}.cls-12{fill:url(#linear-gradient-6);}.cls-13{fill:url(#linear-gradient-7);}.cls-14{fill:url(#linear-gradient-8);}.cls-15{fill:url(#linear-gradient-9);}.cls-16{fill:url(#linear-gradient-10);}.cls-17{fill:url(#linear-gradient-11);}.cls-18{fill:url(#linear-gradient-12);}.cls-19{fill:url(#linear-gradient-13);}.cls-20{fill:url(#linear-gradient-14);}.cls-21{fill:#91b3fa;}.cls-22{fill:url(#linear-gradient-15);}.cls-23{fill:url(#linear-gradient-16);}.cls-24{fill:url(#linear-gradient-17);}.cls-25{fill:url(#linear-gradient-18);}.cls-26{opacity:0.3;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3120.27,
    y1: 3592.94,
    x2: 651.79,
    y2: 527.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 2476.36,
    y1: -885.49,
    x2: 865.05,
    y2: 1333.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 404.63,
    y1: 1711.09,
    x2: 2989.1,
    y2: -3241.29,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 432.17,
    y1: 1725.46,
    x2: 3016.66,
    y2: -3226.95,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 443.78,
    y1: 1921.44,
    x2: 7.74,
    y2: 2395.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 302.25,
    y1: 1956.66,
    x2: 340.98,
    y2: 1956.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 345.96,
    y1: 1831.51,
    x2: -90.08,
    y2: 2305.8,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 162.66,
    y1: 1954.68,
    x2: 196.1,
    y2: 1954.68,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 931.86,
    y1: 266.41,
    x2: 610.96,
    y2: 689.72,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 461.63,
    y1: 946.21,
    x2: 659.5,
    y2: 946.21,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 560.78,
    y1: 928.62,
    x2: 720.09,
    y2: 737.45,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 658.55,
    y1: 812.43,
    x2: 713.95,
    y2: 727.25,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 820.65,
    y1: 182.1,
    x2: 499.75,
    y2: 605.41,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 28.64,
    y1: 1226.49,
    x2: 279.05,
    y2: 1226.49,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 260.46,
    y1: 1200.23,
    x2: 338.47,
    y2: 1200.23,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 220.92,
    y1: 958.79,
    x2: 319.92,
    y2: 958.79,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -5119.29,
    y1: -1727.28,
    x2: -5156.29,
    y2: -1849.31,
    gradientTransform: "matrix(0.75, -0.67, 0.67, 0.75, 5312.66, -1224.58)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -5157.11,
    y1: -1727.85,
    x2: -5190.4,
    y2: -1837.64,
    gradientTransform: "matrix(0.75, -0.67, 0.67, 0.75, 5312.66, -1224.58)",
    xlinkHref: "#linear-gradient-6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2441.18,2383.94c-56.7,59.69-110.35,98.18-152.74,128.6-498.25,357.5-1087.81,253.29-1213.11,227.84-185-37.58-542.68-110.22-801.26-414.3-391.2-460-330.29-1184.85-26.84-1663.29,55.5-87.52,348.7-573.25,944.61-651.15,360.64-47.14,781,47.94,1085.46,303C2916.34,850,2870.85,1931.59,2441.18,2383.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2659.05,2756.55H1868.73V1128.35a40.42,40.42,0,0,1,40.43-40.42h709.47a40.42,40.42,0,0,1,40.42,40.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1676.17,1087.93h709.47a40.42,40.42,0,0,1,40.42,40.42v1628.2a0,0,0,0,1,0,0H1635.74a0,0,0,0,1,0,0V1128.35A40.42,40.42,0,0,1,1676.17,1087.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1701,1392.2a5.12,5.12,0,0,1-5.12-5.12V1260.42c0-66.92,58.67-121.36,130.78-121.36h207.82a5.12,5.12,0,0,1,0,10.24H1826.64c-66.46,0-120.53,49.85-120.53,111.12v126.66A5.13,5.13,0,0,1,1701,1392.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1701,1526.5a5.12,5.12,0,0,1-5.12-5.12v-51.61a5.13,5.13,0,0,1,10.25,0v51.61A5.13,5.13,0,0,1,1701,1526.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1773.62,2756.55H971.12V1433.5a40.43,40.43,0,0,1,40.43-40.43H1733.2a40.42,40.42,0,0,1,40.42,40.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1569.77,2756.55H767.27V1433.5a40.43,40.43,0,0,1,40.42-40.43h721.65a40.43,40.43,0,0,1,40.43,40.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M821.07,1648.11A5.12,5.12,0,0,1,816,1643v-96.74c0-51.77,44.1-93.89,98.31-93.89h154.11a5.12,5.12,0,1,1,0,10.24H914.26c-48.56,0-88.07,37.52-88.07,83.65V1643A5.12,5.12,0,0,1,821.07,1648.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M821.07,1750.68a5.12,5.12,0,0,1-5.12-5.12v-39.41a5.12,5.12,0,1,1,10.24,0v39.41A5.12,5.12,0,0,1,821.07,1750.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M952.12,2756.55H260.63V2059a40.43,40.43,0,0,1,40.42-40.43H911.7A40.42,40.42,0,0,1,952.12,2059Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.2,2018.53H707.84A40.42,40.42,0,0,1,748.27,2059v697.59a0,0,0,0,1,0,0H56.77a0,0,0,0,1,0,0V2059A40.42,40.42,0,0,1,97.2,2018.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M113.86,2230.23a5.13,5.13,0,0,1-5.13-5.12v-87.47c0-47.08,51.63-85.38,115.07-85.38H405.63a5.12,5.12,0,1,1,0,10.24H223.8c-57.8,0-104.82,33.71-104.82,75.14v87.47A5.12,5.12,0,0,1,113.86,2230.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M113.86,2323a5.13,5.13,0,0,1-5.13-5.12v-35.64a5.13,5.13,0,0,1,10.25,0v35.64A5.13,5.13,0,0,1,113.86,2323Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1919.9,1389H602.55a103.52,103.52,0,0,1-103.06-93.8l-83-880.85A103.52,103.52,0,0,1,517.55,301.14l1400.38-26.66A103.52,103.52,0,0,1,2023.42,378v907.51A103.51,103.51,0,0,1,1919.9,1389Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M500.67,492.86l58.88,761.68a64,64,0,0,0,63.16,59.08l1264.37,13.25a64,64,0,0,0,64.69-64v-820a64,64,0,0,0-66.2-64L562.32,423.94A64,64,0,0,0,500.67,492.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M643.93,1188.2H1781.74a60.21,60.21,0,0,0,60.21-60.85l-5.76-531-96.76,122.41-78.34,10s-70.18,2.5-89,5-105.59,22.51-105.59,22.51l-83.67,42.52-19.66,54-57.52,33-62.37,36.67H1116.45l-156-69.65H907.54l-96.14,56-90,104.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M656.48,536.59l713-21.33a13,13,0,0,1,13.35,13V539.7a13,13,0,0,1-12.78,13l-713,9.84a13,13,0,0,1-13.14-13h0A13,13,0,0,1,656.48,536.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 643.9,
    y: 596.36,
    width: 738.92,
    height: 30.82,
    rx: 12.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M647.83,1188.2a24.24,24.24,0,0,1-22.29-33.7c82.17-193.66,174.52-299.09,282.32-322.3,74.25-16,131.69,13.5,182.36,39.53,53.92,27.69,100.5,51.62,164.34,27.5,48.16-18.18,74.55-51.65,102.5-87.07,34.83-44.17,70.85-89.83,147.12-102.77,38.14-6.47,68-1.44,94.28,3,31.83,5.37,57,9.61,91.82-7.22,40.93-19.78,76.76-59.49,106.48-118A24.23,24.23,0,1,1,1840,609.07c-34.64,68.22-77.91,115.24-128.62,139.74-48.75,23.55-85.47,17.36-121,11.36-24.7-4.16-48-8.11-78.11-3-57.87,9.81-85.36,44.65-117.18,85-29.37,37.24-62.67,79.46-123.42,102.4-84,31.71-147.53-.94-203.6-29.74-47.67-24.48-92.7-47.62-150-35.26-90,19.38-173.4,118.25-247.92,293.86A24.22,24.22,0,0,1,647.83,1188.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M306,1956.77s-4.52,25.56-6.73,50.87a17.43,17.43,0,0,0,16.67,18.89c33.7,1.41,105.79,4.13,131.66,3a5.67,5.67,0,0,0,5-7.77,12.69,12.69,0,0,0-6.5-6.84L327,1960.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M302.25,1941.75l3.62,30.58s20.86,9.71,35.11-1.23L332.34,1937Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M305,1366.86c-1.56,8-8.41,398.49,33.33,573.49a5.93,5.93,0,0,1-3.48,6.91,103.2,103.2,0,0,1-34,6.91,10.24,10.24,0,0,1-10.15-7.34c-11.93-40.6-69.1-244-76.56-438.36-8.34-217.15,0-7.4,0-7.4L219,1366.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M169,1970.11s-7.19,12.9-14.15,47.2a10.64,10.64,0,0,0,9.36,12.74c11.13,1.09,28.26,2.5,42,2.4a10.61,10.61,0,0,0,10.5-11.83c-1.52-12.52-6.26-33-20.89-49.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M162.66,1930.78l8.48,46.24s8.38,6.23,25,1.71l-4-49.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.76,1378.85c-34.14,206,7.4,509.23,21.41,568.57a9.26,9.26,0,0,0,7.48,7c6.25,1,16.55,1.88,26.7-1.07a8.49,8.49,0,0,0,6.1-7.81c1.88-48-1.51-342.51,30.3-458.91a26.42,26.42,0,0,1,10.2-14.58l61.74-43.9,4.74-71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M357.29,988.45C255,986.76,142.1,1015.32,142.1,1015.32c-30.5,177.94-5.34,383.19-5.34,383.19,79.21,20.77,168.56-12.7,168.56-12.7,13.16-74.38,74.58-283.7,74.58-283.7,50-6.2,91.17-20.63,125.08-39.69-25.86-30-38.06-68.14-43.35-90.69C425.45,983,388.85,989,357.29,988.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M659.5,837.76c-10-12.14-22.77-6.4-22.77-6.4-15.06,63.6-94,115.16-175.1,140.37,5.29,22.55,17.49,60.7,43.35,90.69C639.58,986.74,659.5,837.76,659.5,837.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M657.06,840.84c1.05,3.35-11.13,8.44-18.3-5.24-.25-6.55-4.23-34.62-.32-40,20.86-28.44,61.29-64.08,61.29-64.08,6.83,6.75,1.2,13.37,1.2,13.37l-19.61,20.43c4.1,7.42,9.11,13.68,11.45,22.64A27.47,27.47,0,0,1,690,808.23c-3.44,6.21-8.14,14.27-12.58,20.58C669,840.75,657.06,840.84,657.06,840.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M672.74,778.62l-17.88,15.15-5.61,15.09,15.94,17.68s5.36-29.93,9.34-36.41S676.45,780.52,672.74,778.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M181.34,1114.38l-39.24-99.06s-95.57,64.93-111.28,147.25c18.06,1.33,50.91,6,83.07,22.27C121,1146,181.34,1114.38,181.34,1114.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M264.85,1207.6s-107.29,60.64-143.49,8.86c-7.52-10.75-9.32-21.44-7.47-31.62-32.16-16.24-65-20.94-83.07-22.27-4.74,24.82-2.23,51.22,12.35,77.89,63.41,116,235.88-6.41,235.88-6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M252,1284.31l58.56-204.49a6,6,0,0,1,5-4.3c10.61-1.23,41.35-4.71,76.84-7.71,42.76-3.62,92.41-6.55,122.08-4a6,6,0,0,1,4.89,8.61c-16.87,34.13-86.27,173-121,218.46a6,6,0,0,1-4.82,2.37l-135.86-1.26A6,6,0,0,1,252,1284.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M398.48,1050.08l42.45-7.07a3,3,0,0,1,3.4,4l-4.21,12.73a3,3,0,0,1-2.49,2.07l-40.85,5.45a3,3,0,0,1-3.37-3.71l2.6-11.12A3,3,0,0,1,398.48,1050.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M366.69,1086l3.5-18.22a4.22,4.22,0,0,1,3.71-3.39l85.75-8.7a4.21,4.21,0,0,1,4.52,5.17l-5.46,22.7a4.19,4.19,0,0,1-3.88,3.22L371,1091A4.21,4.21,0,0,1,366.69,1086Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M266.11,1234.91s-8.16-33.55-4.87-45.45,9.66-27.2,30.91-23.8S338.47,1178,338.47,1178s-1.27,15.5-17.42,10.5l10,7.74s-1.43,12.41-15.07,5.78l9.31,10.28s-5.86,10.19-15.89,3.66S294.57,1238.94,266.11,1234.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M253.66,905.39l-32.55,94.14a3.39,3.39,0,0,0,1.55,4.09c8.87,4.91,40.84,19.09,79.37-5.34a16,16,0,0,0,7.35-11.41l10.54-81.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M324.49,818.21s35.75,67.29,31.17,94.48-48.89,25.23-87.57,3.15l-27-72.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M269.8,880.16A2.78,2.78,0,0,0,271,876.1c-2.87-4.38-8.24-13.3-9.95-21.12,0,0-6.42-4.11,16.36-9.57s56.75-13.91,63.9-33.3c7-18.91-11.34-66.46-40.52-28.57a2.77,2.77,0,0,1-4.39,0c-4.79-6.23-17.37-19.15-34.83-11.32-16.34,7.33-18.18,19.31-18,25.34a2.76,2.76,0,0,1-3.27,2.83c-8.26-1.58-28.09-2.93-37.34,17.41-7.62,16.75-2.67,26.24,1.84,30.88a2.77,2.77,0,0,1-1.18,4.59c-5.43,1.66-12.44,6.26-11.74,19,1,17.58,20.63,16,26.23,15.23a2.79,2.79,0,0,1,2.46.87c4.81,5.32,26.43,27.87,49.84,30.59a2.79,2.79,0,0,0,2.94-3.69l-10.13-29.45a2.79,2.79,0,0,1,1.5-3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M273.87,884.34s-25.45-17.46-27.31-2.76,22.92,21.3,35.19,15.82Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 925.41,
    y: 2445.99,
    width: 1866.01,
    height: 354.01,
    rx: 21.39,
    transform: "translate(3716.84 5245.99) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2453.39,
    y: 2486.67,
    width: 172.29,
    height: 272.64,
    rx: 7.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2363.4,
    y: 2486.67,
    width: 64.65,
    height: 272.64,
    rx: 5.89
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M2357.7,247.06a6,6,0,0,1,3.88-7.08c6.42-2.26,13.05-4.27,19.68-6a6,6,0,0,1,7.35,4.34l0,.11a6,6,0,0,1-4.36,7.24c-6.31,1.62-12.6,3.53-18.71,5.68a6,6,0,0,1-7.69-3.7A6.13,6.13,0,0,1,2357.7,247.06Zm51.23-11.77a5.55,5.55,0,0,1-.13-.71,6,6,0,0,1,5.3-6.69c6.8-.79,13.7-1.29,20.51-1.5a6,6,0,0,1,.37,12.06c-6.47.2-13,.68-19.49,1.43A6,6,0,0,1,2408.93,235.29Zm52.54-.2a6.37,6.37,0,0,1-.13-2.05,6,6,0,0,1,6.66-5.35c6.79.75,13.63,1.79,20.33,3.12a6,6,0,1,1-2.33,11.83c-6.37-1.25-12.86-2.25-19.31-2.95A6,6,0,0,1,2461.47,235.09Zm51.28,11.55a6,6,0,0,1,7.85-7.09c6.46,2.25,12.89,4.8,19.13,7.58a6,6,0,1,1-4.92,11c-5.92-2.64-12-5.07-18.17-7.2A6,6,0,0,1,2512.75,246.64Zm47.41,22.7a6,6,0,0,1,9.07-6.51c5.78,3.61,11.49,7.52,17,11.62a6,6,0,0,1-7.23,9.66c-5.21-3.9-10.64-7.62-16.13-11.05A6,6,0,0,1,2560.16,269.34ZM2601.37,302a6,6,0,0,1,10.12-5.68c4.85,4.8,9.55,9.88,14,15.09a6,6,0,0,1-9.2,7.81c-4.2-4.94-8.67-9.77-13.28-14.34A6,6,0,0,1,2601.37,302Zm65.09,211.77a6.07,6.07,0,0,1-.05-2.55c1.25-6.36,2.23-12.87,2.93-19.33a6,6,0,0,1,12,1.29c-.73,6.81-1.76,13.65-3.07,20.35a6,6,0,0,1-11.8.24Zm-32.15-170.85a6,6,0,0,1,11-4.63c3.66,5.77,7.11,11.76,10.26,17.82a6,6,0,1,1-10.7,5.57c-3-5.76-6.27-11.45-9.75-16.93A6.21,6.21,0,0,1,2634.31,342.88Zm36.36,118.46a6,6,0,0,1-.16-1.2c-.21-6.49-.7-13.05-1.47-19.5a6,6,0,1,1,12-1.41c.8,6.79,1.32,13.69,1.54,20.51a6,6,0,0,1-11.9,1.6Zm-13.39-71.22a6,6,0,0,1,11.56-3.4c2.27,6.44,4.29,13,6,19.67a.31.31,0,0,1,0,.13,6,6,0,0,1-11.7,2.91c-1.64-6.29-3.56-12.57-5.72-18.69A6.32,6.32,0,0,1,2657.28,390.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M2654.6,554.4a6,6,0,0,1,.26-3.6c1.13-2.89,2.23-5.86,3.26-8.82a6,6,0,1,1,11.39,4c-1.07,3.11-2.23,6.23-3.42,9.27a6,6,0,0,1-11.49-.81Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M2525.83,685.74a6,6,0,0,1,3.57-7c2.87-1.19,5.77-2.46,8.61-3.77a6,6,0,1,1,5.06,11c-3,1.38-6,2.72-9.06,4a6,6,0,0,1-7.88-3.27A5.2,5.2,0,0,1,2525.83,685.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M2207.3,523.23q-1-4.05-1.79-8.16a6,6,0,1,1,11.82-2.4c1.28,6.33,2.82,12.59,4.59,18.69a6,6,0,0,1-11.59,3.36C2209.23,531,2208.22,527.09,2207.3,523.23Zm-6-39.74a6.78,6.78,0,0,1-.16-1c-.43-6.71-.58-13.53-.44-20.24a6,6,0,1,1,12.06.24c-.13,6.38,0,12.85.42,19.23a6,6,0,0,1-11.88,1.79Zm19.93,81a6,6,0,0,1,11.38-3.84c2.59,5.82,5.47,11.61,8.56,17.21a6,6,0,1,1-10.56,5.83c-3.26-5.9-6.29-12-9-18.13A5.39,5.39,0,0,1,2221.27,564.52Zm-17.54-132.71a5.92,5.92,0,0,1-.08-2.34c1-6.64,2.4-13.32,4-19.84a6,6,0,0,1,11.72,2.89c-1.53,6.19-2.82,12.53-3.82,18.84a6,6,0,0,1-11.83.45Zm43.68,177.3a6,6,0,0,1,10.71-5c3.81,5.1,7.89,10.12,12.14,14.9a6,6,0,0,1-9,8c-4.47-5-8.77-10.32-12.78-15.7A6,6,0,0,1,2247.41,609.11Zm35.3,37.78a6,6,0,0,1,9.8-6c4.85,4.16,9.93,8.17,15.1,11.9a6,6,0,1,1-7.06,9.78c-5.45-3.93-10.79-8.15-15.9-12.52A6.13,6.13,0,0,1,2282.71,646.89Zm42.7,29.18a6,6,0,0,1,8.71-6.72c5.64,3,11.47,5.81,17.33,8.33a6,6,0,1,1-4.77,11.08c-6.16-2.65-12.3-5.6-18.24-8.76A6,6,0,0,1,2325.41,676.07Zm48,19.17a6,6,0,0,1,7.47-7.21c6.17,1.7,12.47,3.16,18.74,4.33a6,6,0,0,1-2.21,11.86c-6.61-1.23-13.25-2.77-19.74-4.56A6,6,0,0,1,2373.45,695.24Zm51.09,8.16a6.23,6.23,0,0,1-.15-1.68,6,6,0,0,1,6.31-5.75c6.37.3,12.83.34,19.22.1a6,6,0,0,1,.45,12.06c-6.73.25-13.53.21-20.24-.1A6,6,0,0,1,2424.54,703.4Zm51.61-3.26c0-.12-.05-.25-.08-.37a6,6,0,0,1,4.91-7c4.64-.8,9.3-1.76,13.87-2.85,1.65-.39,3.3-.8,4.93-1.23a6,6,0,0,1,7.36,4.32,6,6,0,0,1-4.31,7.36c-1.73.45-3.45.88-5.19,1.29-4.81,1.14-9.71,2.15-14.59,3A6,6,0,0,1,2476.15,700.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M2217.51,381.79a6,6,0,0,1,.26-3.62c1.21-3,2.51-6.1,3.85-9.11a6,6,0,1,1,11,4.92c-1.28,2.87-2.51,5.78-3.66,8.66a6,6,0,0,1-11.47-.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M2287.47,373.54a2.81,2.81,0,0,0-.11,3.27l19,28.6a149.41,149.41,0,0,0-12.48,46.8l-30.67,15.36a2.82,2.82,0,0,0-1.53,2.89l5.43,40.81a2.83,2.83,0,0,0,2.24,2.39l33.61,6.8a149.35,149.35,0,0,0,24.3,41.9l-10.83,32.57a2.83,2.83,0,0,0,1,3.13l32.7,25a2.81,2.81,0,0,0,3.27.11l28.6-19a149.14,149.14,0,0,0,46.8,12.48l15.36,30.67a2.81,2.81,0,0,0,2.89,1.53l40.81-5.43a2.83,2.83,0,0,0,2.39-2.24l6.81-33.61a149.49,149.49,0,0,0,41.9-24.3l32.57,10.83a2.81,2.81,0,0,0,3.12-1l25-32.7a2.83,2.83,0,0,0,.11-3.27l-19-28.6a149.42,149.42,0,0,0,12.49-46.8l30.66-15.36a2.83,2.83,0,0,0,1.54-2.89L2620,422.75a2.82,2.82,0,0,0-2.23-2.39l-33.62-6.8a149.62,149.62,0,0,0-24.29-41.91l10.82-32.56a2.81,2.81,0,0,0-1-3.13L2537,311a2.83,2.83,0,0,0-3.28-.11l-28.59,19a149.57,149.57,0,0,0-46.8-12.49L2443,286.66a2.8,2.8,0,0,0-2.89-1.53l-40.8,5.43a2.83,2.83,0,0,0-2.4,2.24l-6.8,33.61a149.35,149.35,0,0,0-41.9,24.3l-32.57-10.83a2.81,2.81,0,0,0-3.13,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2403.27,476.55a41.38,41.38,0,1,1,1.83,5.79A41.43,41.43,0,0,1,2403.27,476.55Zm71.15-16.81a31.73,31.73,0,1,0-19.13,36.74,31.75,31.75,0,0,0,19.13-36.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2345.32,491.19a102.9,102.9,0,0,1-1.91-10.28h0c-.14-1.09-.27-2.19-.38-3.29a102,102,0,0,1-.34-16.29,1.7,1.7,0,0,0,0-.22c0-.21,0-.42.05-.63,0-.41.06-.82.09-1.22a2.41,2.41,0,1,1,4.81.38,97,97,0,0,0,55.91,95.77,96.91,96.91,0,1,0,27.92-184q-4.91.66-9.68,1.79A96.82,96.82,0,0,0,2384,391.59a2.29,2.29,0,0,1-.94.46,2.41,2.41,0,0,1-2.06-4.23,101.27,101.27,0,0,1,39.72-19.31,98.77,98.77,0,0,1,10.16-1.88A101.75,101.75,0,0,1,2468,566.43a103.83,103.83,0,0,1-10.3,1.91,101.77,101.77,0,0,1-112.38-77.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M2155.42,83.52a3.74,3.74,0,0,1,1.78-4.1c2.74-1.57,5.58-3.07,8.42-4.48a3.73,3.73,0,0,1,3.3,6.68c-2.71,1.34-5.41,2.78-8,4.27a3.73,3.73,0,0,1-5.08-1.38A3.78,3.78,0,0,1,2155.42,83.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M2181.51,71.65a3.72,3.72,0,0,1,2.4-4.38,160,160,0,0,1,15.74-4.59c1.11-.27,2.23-.52,3.36-.77a3.86,3.86,0,0,1,4.43,2.86,3.72,3.72,0,0,1-2.85,4.43c-1.08.23-2.15.47-3.22.73a154.21,154.21,0,0,0-15,4.38,3.72,3.72,0,0,1-4.74-2.29C2181.58,71.89,2181.54,71.77,2181.51,71.65Zm37.82-8.15a3.08,3.08,0,0,1-.08-.53,3.72,3.72,0,0,1,3.37-4,162.17,162.17,0,0,1,19.83-.57,3.73,3.73,0,0,1-.25,7.45,153.21,153.21,0,0,0-18.91.55A3.74,3.74,0,0,1,2219.33,63.5ZM2258,64.77a3.66,3.66,0,0,1-.05-1.44,3.72,3.72,0,0,1,4.26-3.1,158.79,158.79,0,0,1,19.37,4.32,3.73,3.73,0,0,1-2.06,7.16A151.69,151.69,0,0,0,2261,67.59,3.74,3.74,0,0,1,2258,64.77Zm37.18,10.74a3.69,3.69,0,0,1,.2-2.33,3.73,3.73,0,0,1,4.89-2A163.18,163.18,0,0,1,2318,80.15a3.72,3.72,0,1,1-3.76,6.43,154.24,154.24,0,0,0-16.89-8.51A3.69,3.69,0,0,1,2295.18,75.51ZM2328.6,95a3.73,3.73,0,0,1,5.89-3.83,162.27,162.27,0,0,1,15,13,3.73,3.73,0,1,1-5.2,5.34A154.71,154.71,0,0,0,2330,97.1,3.75,3.75,0,0,1,2328.6,95Zm27.68,27a3.73,3.73,0,0,1,6.54-3.19,161.37,161.37,0,0,1,11.4,16.22,3.73,3.73,0,1,1-6.36,3.9A153.35,153.35,0,0,0,2357,123.47,3.67,3.67,0,0,1,2356.28,122ZM2376.51,155a3.73,3.73,0,0,1,7-2.4,161.07,161.07,0,0,1,7.07,18.53,3.73,3.73,0,1,1-7.11,2.23,151.73,151.73,0,0,0-6.75-17.67A3.73,3.73,0,0,1,2376.51,155Zm13.84,56.18a3.52,3.52,0,0,1-.1-.65,154.17,154.17,0,0,0-1.83-16.36q-.2-1.23-.42-2.43a3.74,3.74,0,0,1,3-4.34,3.7,3.7,0,0,1,4.34,3c.16.85.31,1.71.45,2.57a162.87,162.87,0,0,1,1.91,17.13,3.72,3.72,0,0,1-7.34,1.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M2080.94,258.56a3.73,3.73,0,0,1,7.24-1.77,153.57,153.57,0,0,0,5.62,17.74,3.72,3.72,0,1,1-7,2.68,160.05,160.05,0,0,1-5.89-18.6Zm-3.52-18.73c0-.13-.06-.26-.08-.4a164.62,164.62,0,0,1-1.29-19.47,3.73,3.73,0,0,1,7.45-.05,156,156,0,0,0,1.24,18.58,3.73,3.73,0,0,1-7.32,1.34Zm17.2,54.24a3.73,3.73,0,0,1,6.91-2.62,152.83,152.83,0,0,0,9.75,15.86,3.73,3.73,0,0,1-6.11,4.28A160.28,160.28,0,0,1,2095,295,3.47,3.47,0,0,1,2094.62,294.07Zm-17.42-92.31a4,4,0,0,1-.07-1.3,158.41,158.41,0,0,1,3.45-19.21,3.73,3.73,0,0,1,7.24,1.76,153.48,153.48,0,0,0-3.29,18.32,3.73,3.73,0,0,1-7.33.43Zm39.27,123.45a3.73,3.73,0,0,1,6.39-3.36,152.74,152.74,0,0,0,13.27,13,3.73,3.73,0,0,1-4.9,5.62,161.79,161.79,0,0,1-13.91-13.68A3.71,3.71,0,0,1,2116.47,325.21Zm28.68,25a3.73,3.73,0,0,1,5.72-3.95,155.68,155.68,0,0,0,16,9.5,3.73,3.73,0,0,1-3.41,6.63,163.87,163.87,0,0,1-16.78-10A3.77,3.77,0,0,1,2145.15,350.21Zm33.85,17.4a3.78,3.78,0,0,1,.13-2.15,3.73,3.73,0,0,1,4.79-2.2,152.79,152.79,0,0,0,17.82,5.38,3.73,3.73,0,1,1-1.72,7.25,161.16,161.16,0,0,1-18.68-5.64A3.73,3.73,0,0,1,2179,367.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M2086.26,164.61a3.64,3.64,0,0,1,.14-2.18c1.13-3,2.35-6,3.63-8.81a3.72,3.72,0,0,1,6.8,3c-1.22,2.73-2.38,5.56-3.46,8.41a3.73,3.73,0,0,1-4.81,2.16A3.69,3.69,0,0,1,2086.26,164.61Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M2133.81,156.49a1.89,1.89,0,0,0-.08,2.19l12.7,19.14a100.19,100.19,0,0,0-8.36,31.31l-20.51,10.28a1.89,1.89,0,0,0-1,1.94l3.64,27.3a1.87,1.87,0,0,0,1.49,1.6l22.5,4.56a99.92,99.92,0,0,0,16.25,28l-7.24,21.79a1.87,1.87,0,0,0,.64,2.09l21.88,16.74a1.88,1.88,0,0,0,2.19.07L2197,310.85a100.17,100.17,0,0,0,31.31,8.35l10.28,20.52a1.9,1.9,0,0,0,1.94,1l27.3-3.64a1.89,1.89,0,0,0,1.6-1.5l4.56-22.49a99.75,99.75,0,0,0,28-16.26l21.8,7.25a1.9,1.9,0,0,0,2.09-.64l16.74-21.88a1.88,1.88,0,0,0,.07-2.19l-12.69-19.14a100.16,100.16,0,0,0,8.35-31.32l20.52-10.28a1.89,1.89,0,0,0,1-1.93l-3.64-27.31a1.9,1.9,0,0,0-1.5-1.6l-22.49-4.55a100,100,0,0,0-16.26-28l7.25-21.79a1.89,1.89,0,0,0-.65-2.09l-21.87-16.74a1.89,1.89,0,0,0-2.19-.08l-19.14,12.7a99.89,99.89,0,0,0-31.32-8.35l-10.28-20.52a1.87,1.87,0,0,0-1.93-1L2208.62,101a1.87,1.87,0,0,0-1.6,1.49l-4.55,22.5a100.16,100.16,0,0,0-28,16.25L2152.64,134a1.88,1.88,0,0,0-2.1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2210.8,225.5a28.27,28.27,0,1,1,1.26,4A29.12,29.12,0,0,1,2210.8,225.5Zm47.61-11.24a20.68,20.68,0,0,0-27.86-14.48A20.74,20.74,0,0,0,2219,226.72h0a20.73,20.73,0,0,0,39.43-12.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2170.45,235.64a70.8,70.8,0,0,1-1.75-21.32l.05-.64a3.73,3.73,0,0,1,2.85-3.33,3.79,3.79,0,0,1,1.17-.08,3.72,3.72,0,0,1,3.41,4,62.76,62.76,0,0,0,.36,13.35h0c0,.25.07.49.1.73a62.23,62.23,0,0,0,11.69,28.42,63.09,63.09,0,0,0,11.83,12.06l.11.09.34.26a62.35,62.35,0,0,0,46.4,12.36q3.22-.44,6.35-1.17a62.75,62.75,0,1,0-53.67-110.15,3.82,3.82,0,0,1-1.46.71,3.73,3.73,0,0,1-3.18-6.55,70.08,70.08,0,0,1,27.4-13.32q3.47-.82,7-1.3a70.2,70.2,0,1,1-59,85.87Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness4);
export default __webpack_public_path__ + "static/media/business_4.03d47e2aac1c3a874c067726c13f51d7.svg";
export { ForwardRef as ReactComponent };